import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-mobile-number-modal',
  templateUrl: './mobile-number-modal.component.pug',
  styleUrls: ['./mobile-number-modal.component.scss'],
  standalone: false
})
export class MobileNumberModalComponent implements OnInit {
  @Input() phone: string = '';
  @Input() isVerified: boolean = false;
  public event: EventEmitter<any> = new EventEmitter();

  mobile: string = '';
  initialMobile: string = '';
  isLoading: boolean = false;

  get hasChanges(): boolean {
    return this.mobile !== this.initialMobile;
  }

  /**
   * Determines if the save button should be disabled.
   * - If unverified: always enabled (user must verify)
   * - If verified: disabled when no changes
   */
  get isSaveDisabled(): boolean {
    if (!this.isVerified) {
      return false;
    }
    return !this.hasChanges; // Disabled only if no changes for verified numbers
  }

  constructor(public _bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.mobile = this.phone || '';
    this.initialMobile = this.mobile;
  }

  onPhoneUpdate(update: any) {
    this.mobile = update?.phone || '';
  }

  cancel() {
    this._bsModalRef.hide();
  }

  save() {
    // For verified numbers with no changes, just close
    if (this.isVerified && !this.hasChanges) {
      this._bsModalRef.hide();
      return;
    }

    // Emit the phone number. For unverified numbers (even without changes),
    // this triggers the verification flow. For changed numbers, this triggers
    // the verification modal. Parent will call closeModal() after verification
    // succeeds or if no verification is needed.
    this.event.emit({ phone: this.mobile, action: 'save' });
  }

  /**
   * Called by parent after verification flow completes to close this modal.
   */
  closeModal() {
    this.initialMobile = this.mobile;
    this._bsModalRef.hide();
  }

  /**
   * Resets the mobile value to initial state (used when verification is cancelled).
   */
  resetToInitial() {
    this.mobile = this.initialMobile;
  }
}


